(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
// Custom JS to trigger the plugin to reload when first item is added to cart. Without it the timer only shows on full page reload if cart was initially empty.
(function () {
  const CART_HOST_SELECTOR = '.cart__inner [countdown-timer-id]';

  
  const APP_SCRIPT_SRC = 'https://cdn.shopify.com/extensions/56a575c1-0852-465a-b663-d28c90b4c98a/countdown-timer-essential-34/assets/countdown_timer_essential_apps.min.js';

  const APP_SCRIPT_SELECTOR = `script[src="${APP_SCRIPT_SRC}"]`;

  let inited = false;

  function getCartHost() {
    return document.querySelector(CART_HOST_SELECTOR);
  }

  function initCountdown() {
    if (inited) return;
    const host = getCartHost();
    if (!host) return;

    // Make sure it's in the DOM and visible enough for the app to find it
    host.classList.remove('is-inert');
    host.innerHTML = ''; // clear any stale render

    const existing = document.querySelector(APP_SCRIPT_SELECTOR);
    if (existing) {
      // App embed already loaded (e.g. announcement bar). Ask it to refresh; fall back later if needed.
      if (window.ectbApp && typeof window.ectbApp.reload === 'function') {
        window.ectbApp.reload();
        inited = true;
        return;
      }
      document.dispatchEvent(new CustomEvent('ECTB_RELOAD'));

      // If the host is still empty shortly after, do a scoped reload to pick it up.
      setTimeout(() => {
        if (inited || host.children.length) return;

        document.querySelectorAll('.countdown-timer-block').forEach(el => { el.innerHTML = ''; });
        document.querySelectorAll(`script[data-ectb]`).forEach(s => s.remove());

        const s = document.createElement('script');
        s.src = APP_SCRIPT_SRC;
        s.async = true;
        s.defer = true;
        s.dataset.ectb = '1';
        s.onload = () => { inited = true; };
        document.head.appendChild(s);
      }, 150);
      return;
    }

    // Re-run the app by (re)loading its script (cart-only flow)
    // 1) remove any previous tag to force a clean run
    document.querySelectorAll(`script[data-ectb]`).forEach(s => s.remove());

    // 2) inject a fresh tag (mark it so we can find/remove later)
    const s = document.createElement('script');
    s.src = APP_SCRIPT_SRC;
    s.async = true;
    s.defer = true;
    s.dataset.ectb = '1';
    s.onload = () => { inited = true; };
    document.head.appendChild(s);
  }

  async function getCartCount() {
    try {
      const r = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await r.json();
      return cart.item_count || 0;
    } catch (e) {
      return 0;
    }
  }

  document.addEventListener('DOMContentLoaded', async () => {
    const host = getCartHost();
    if (!host) return;

    // Keep the node present but inert until we need it
    host.classList.add('is-inert');

    // Rivet-cart fires a jQuery event after cart updates — use it as a primary trigger.
    if (window.jQuery) {
      window.jQuery(document).on('cart.requestComplete', (_evt, cart) => {
        if (cart && cart.item_count > 0) {
          initCountdown();
        }
      });
    }

    const count = await getCartCount();
    if (count > 0) {
      initCountdown();                 // already has items — init now
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-blog"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

// grab the nav element
    var blogNav = document.querySelector('.page-blog__nav');

// on scroll, check how far the page is scrolled
    window.addEventListener('scroll', function() {

// if scrolled down more than 0px, add the class; otherwise remove it
      if (window.pageYOffset > 0) {
        blogNav.classList.add('scrolled');
      } else {
        blogNav.classList.remove('scrolled');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
